const  showMenu = (old=false, action) => {
    let { type, payload} = action
    switch (type) {
        case "showMenu":
            return payload
        default:
            return old;
    }
}
export default showMenu